/**
 * Hands the reader a text or bytes as a file.
 *
 * The one part of the export that needs a browser, kept apart so that everything with a
 * rule in it stays a pure function. The URL is revoked once the click has been dispatched:
 * the download has taken its own reference by then.
 */
export function downloadBlob(name: string, data: BlobPart, type: string): void {
  const url = URL.createObjectURL(new Blob([data], { type }))
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = name
  anchor.style.display = 'none'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}

export function downloadText(name: string, text: string, type = 'text/csv;charset=utf-8'): void {
  downloadBlob(name, text, type)
}
